var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeWidth: 1.2,
    d: "m15.609 13.517-2.251 1.3a.426.426 0 0 1-.582-.161L9.9 9.672a.426.426 0 0 1 .15-.584l2.252-1.3c.545-.314.792-.976.586-1.585L11.73 3.419c-.273-.81-1.21-1.175-1.94-.754l-.65.376.025-.015.003.006C5.834 5.173 5.074 10.178 7.5 14.38c2.426 4.201 7.14 6.046 10.664 4.228l.003.005.623-.36c.73-.42.882-1.415.315-2.055l-1.833-2.393a1.328 1.328 0 0 0-1.663-.288Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.5051521e.svg";
export { ForwardRef as ReactComponent };